import React, { useState } from "react";
import { Row, Col, Container, Button } from "react-bootstrap";
import "./ChangePassword.css";
import apiCall from "../../API/API";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";

const ChangePassword = () => {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [reverifyPassword, setReverifyPassword] = useState("");
  const [showOld, setShowOld] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showReverify, setShowReverify] = useState(false);
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("authToken");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (newPassword !== reverifyPassword) {
      toast.error("New password and reverify password do not match");
      return;
    }

    setLoading(true);
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: token,
        },
      };

      const { data, error } = await apiCall(
        "post",
        "/update-admin-password",
        {
          oldPassword,
          newPassword,
        },
        config
      );

      if (data) {
        toast.success(data.message || "Password changed successfully");
        setOldPassword("");
        setNewPassword("");
        setReverifyPassword("");
      } else if (error) {
        toast.error(error.message || "An error occurred");
      }
    } catch (error) {
      toast.error(error.message || "An error occurred");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="mt-4">
      <section id="change-password-section">
        <div className="d-flex justify-content-center">
          <h2>Change Password</h2>
        </div>
        <section id="formContent">
          <div className="form">
            <Row>
              <Col lg={6} style={{ margin: "auto" }}>
                <form onSubmit={handleSubmit}>
                  <div className="mb-3 position-relative">
                    <label htmlFor="oldPassword">Old Password:</label>
                    <input
                      type={showOld ? "text" : "password"}
                      id="oldPassword"
                      className="form-control"
                      value={oldPassword}
                      onChange={(e) => setOldPassword(e.target.value)}
                      placeholder="Enter Old Password"
                      required
                    />
                  </div>
                  <div className="mb-3 position-relative">
                    <label htmlFor="newPassword">New Password:</label>
                    <input
                      type={showNew ? "text" : "password"}
                      id="newPassword"
                      className="form-control"
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                      placeholder="Enter New Password"
                      required
                    />
                    <i
                      onClick={() => setShowNew(!showNew)}
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "32px",
                        cursor: "pointer",
                      }}
                    >
                      {showNew ? <FaRegEye /> : <FaRegEyeSlash />}
                    </i>
                  </div>
                  <div className="mb-3 position-relative">
                    <label htmlFor="reverifyPassword">Confirm Password:</label>
                    <input
                      type={showReverify ? "text" : "password"}
                      id="reverifyPassword"
                      className="form-control"
                      value={reverifyPassword}
                      onChange={(e) => setReverifyPassword(e.target.value)}
                      placeholder="Re-enter New Password"
                      required
                    />
                    <i
                      onClick={() => setShowReverify(!showReverify)}
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "32px",
                        cursor: "pointer",
                      }}
                    >
                      {showReverify ? <FaRegEye /> : <FaRegEyeSlash />}
                    </i>
                  </div>
                  <Button type="submit" variant="primary" disabled={loading}>
                    {loading ? "Submitting..." : "Change Password"}
                  </Button>
                </form>
              </Col>
            </Row>
          </div>
        </section>
      </section>
    </Container>
  );
};

export default ChangePassword;
